/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./group-item-header.vue?vue&type=template&id=8c982b4e&scoped=true&"
import script from "./group-item-header.vue?vue&type=script&lang=js&"
export * from "./group-item-header.vue?vue&type=script&lang=js&"
import style0 from "./group-item-header.vue?vue&type=style&index=0&id=8c982b4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c982b4e",
  null
  
)

export default component.exports